"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var Icon_1 = __importDefault(require("../Icon"));
var Dropdown_1 = __importDefault(require("../Dropdown"));
var Typography_1 = __importDefault(require("../Typography"));
var styles_1 = require("./styles");
var consts_1 = require("./consts");
var utils_1 = require("./utils");
var Pagination = function (_a) {
    var totalCount = _a.totalCount, currentPage = _a.currentPage, rowPerPage = _a.rowPerPage, onPageChange = _a.onPageChange, onRowPerPageChange = _a.onRowPerPageChange, _b = _a.bordered, bordered = _b === void 0 ? false : _b, _c = _a.messages, messages = _c === void 0 ? utils_1.defaultMessages : _c;
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    var _d = (0, react_1.useState)(false), isWrapped = _d[0], setIsWrapped = _d[1];
    var containerRef = (0, react_1.useRef)(null);
    var handleRowCountChange = function (value) {
        onRowPerPageChange(value);
    };
    // Function to check if items are wrapped
    var checkIfWrapped = function () {
        if (!containerRef.current)
            return;
        var container = containerRef.current;
        var topRow = container.querySelector('[data-top-row]');
        var pageNumbers = container.querySelector('[data-page-numbers]');
        if (!topRow || !pageNumbers)
            return;
        // Check if TopRow and PageNumbers are on the same horizontal line
        var topRowRect = topRow.getBoundingClientRect();
        var pageNumbersRect = pageNumbers.getBoundingClientRect();
        // If the top of pageNumbers is significantly below the top of topRow, they're wrapped
        var wrapped = Math.abs(pageNumbersRect.top - topRowRect.top) > 20; // 20px threshold
        setIsWrapped(wrapped);
    };
    (0, react_1.useEffect)(function () {
        // Check on mount and when dependencies change
        checkIfWrapped();
        // Use ResizeObserver to detect layout changes (if available)
        var resizeObserver = null;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(function () {
                checkIfWrapped();
            });
            if (containerRef.current) {
                resizeObserver.observe(containerRef.current);
            }
        }
        // Also listen to window resize as a fallback
        var handleResize = function () {
            setTimeout(checkIfWrapped, 0); // Use setTimeout to ensure layout has updated
        };
        window.addEventListener('resize', handleResize);
        return function () {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            window.removeEventListener('resize', handleResize);
        };
    }, [totalCount, currentPage, rowPerPage]); // Re-run when pagination data changes
    var maximumOption = consts_1.ROWS_PER_PAGE_OPTIONS.filter(function (_a) {
        var value = _a.value;
        return value < totalCount;
    }).length + 1;
    var dropdownOptions = consts_1.ROWS_PER_PAGE_OPTIONS.slice(0, maximumOption);
    var paginationRange = (0, utils_1.usePagination)({
        currentPage: currentPage,
        totalCount: totalCount,
        rowPerPage: rowPerPage,
    });
    var onNext = function () {
        onPageChange(currentPage + 1);
    };
    var onPrevious = function () {
        onPageChange(currentPage - 1);
    };
    var handlePageChange = function (pageNumber) {
        onPageChange(pageNumber);
    };
    var handleKeyDown = function (e, action) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            action();
        }
    };
    var lastPage = paginationRange[paginationRange.length - 1];
    return ((0, jsx_runtime_1.jsxs)(styles_1.PaginationContainer, __assign({ bordered: bordered, ref: containerRef }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.TopRow, __assign({ "data-top-row": true, isWrapped: isWrapped }, { children: [(0, jsx_runtime_1.jsx)(styles_1.PagesShown, { children: (0, jsx_runtime_1.jsx)(Typography_1.default.Body, { children: formatMessage(messages.pageCurrentOfLast, { currentPage: currentPage, lastPage: lastPage }) }) }), totalCount > 10 && ((0, jsx_runtime_1.jsxs)(styles_1.RowsPerPage, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default.Body, { children: messages.rowsPerPage }), (0, jsx_runtime_1.jsx)(Dropdown_1.default, { value: rowPerPage, size: "md", options: dropdownOptions, floatable: true, onChange: handleRowCountChange, direction: "up" })] }))] })), totalCount > 10 && ((0, jsx_runtime_1.jsx)(styles_1.PageNumbersWrapper, __assign({ "data-page-numbers": true }, { children: (0, jsx_runtime_1.jsxs)(styles_1.PageNumbers, { children: [(0, jsx_runtime_1.jsxs)(styles_1.PaginationItem, __assign({ "data-testid": "previousBtn", className: currentPage === 1 ? 'disabled' : '', onClick: onPrevious, onKeyDown: function (e) { return handleKeyDown(e, onPrevious); }, tabIndex: currentPage === 1 ? -1 : 0, role: "button", "aria-label": messages.previous }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { size: "s", name: "arrow-left" }), (0, jsx_runtime_1.jsx)(styles_1.ButtonText, { children: (0, jsx_runtime_1.jsx)(Typography_1.default.Body, { children: messages.previous }) })] })), paginationRange.map(function (pageNumber, index) { return ((0, jsx_runtime_1.jsx)(styles_1.PaginationItem, __assign({ "data-testid": "page".concat(pageNumber), className: (0, classnames_1.default)({
                                selected: pageNumber === currentPage,
                                disabled: pageNumber === utils_1.DOTS,
                            }), onClick: function () { return handlePageChange(pageNumber); }, onKeyDown: function (e) { return handleKeyDown(e, function () { return handlePageChange(pageNumber); }); }, tabIndex: pageNumber === utils_1.DOTS ? -1 : 0, role: "button", "aria-label": pageNumber === utils_1.DOTS ? 'Ellipsis' : "Page ".concat(pageNumber), "aria-current": pageNumber === currentPage ? 'page' : undefined }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default.Body, __assign({ as: "span" }, { children: pageNumber === utils_1.DOTS ? utils_1.DOTS : pageNumber })) }), index)); }), (0, jsx_runtime_1.jsxs)(styles_1.PaginationItem, __assign({ "data-testid": "nextBtn", className: currentPage === lastPage ? 'disabled' : '', onClick: onNext, onKeyDown: function (e) { return handleKeyDown(e, onNext); }, tabIndex: currentPage === lastPage ? -1 : 0, role: "button", "aria-label": messages.next }, { children: [(0, jsx_runtime_1.jsx)(styles_1.ButtonText, { children: (0, jsx_runtime_1.jsx)(Typography_1.default.Body, { children: messages.next }) }), (0, jsx_runtime_1.jsx)(Icon_1.default, { size: "s", name: "arrow-right" })] }))] }) })))] })));
};
exports.default = Pagination;
